export default __webpack_public_path__ + "70093df527bc664061f843f8f86d8bf3.obj";